import { getCDNUrl } from './CDNUrl';
import { Link } from 'react-router-dom';

const salesCDN = (fileName) => getCDNUrl('service', fileName);

export const IMG_SALES_ITEM = salesCDN(`babyface_thumnail_img_1.jpg`);

export const SALES_ITEM_IMAGE_LIST = [
  ...Array(4)
    .fill({ src: '', alt: '' })
    .map((image, idx) => {
      return {
        src: salesCDN(idx === 0 ? `babyface_thumnail_img_${idx}.gif` : `babyface_thumnail_img_${idx-1}.jpg`),
        alt: '베이비페이스 썸네일 이미지',
      };
    }),
  {
    src: {
      video: salesCDN('babyface_thumnail_video.mp4'),
      thumbnail: salesCDN(`babyface_thumnail_img_5.jpg`),
      poster: salesCDN(`babyface_thumnail_img_55.jpg`),
    },
    alt: '베이비페이스 소개영상',
  },
];

const babyfaceCDN = (fileName) => getCDNUrl('service/babyface', fileName);

const babyfaceAccCDN = (fileName) =>
  getCDNUrl('service/babyface_acc', fileName);

const BABYFACE_ACC_PHOTOSTAND_IMAGES = Array(2)
  .fill()
  .map((_, idx) => {
    return {
      src: babyfaceAccCDN(`detail_photostand_0${idx + 1}@3x.jpg`),
      alt: '베이비페이스 부가상품 포토스탠드 상세',
    };
  });

const THE_GOLDEN_COMPASS_VIDEO = {
  src: salesCDN('The_Golden_Compass_video.mp4'),
  poster: salesCDN('The_Golden_Compass_video@2x.jpg'),
  alt: '황금나침반 출연 영상',
};

export const BABYFACE_ACC_DETAIL_IMAGES = [
  {
    src: babyfaceAccCDN(`detail@3x.jpg`),
    alt: '베이비페이스 부가상품 요약',
  },
  ...BABYFACE_ACC_PHOTOSTAND_IMAGES,
];


const eventCDN = (fileName) => getCDNUrl('service/event', fileName);

export const EVENT_IMAGES = [
  {
    src: eventCDN(`event_fall.jpg`),
    alt: '특가 이벤트 설명 이미지',
  },
];

export const RECEIPT_EVENT_BUTTON_IMAGE = {
  src: eventCDN(`event_receipt_button.png`),
  alt: '영수증 리뷰 작성 이벤트 상세보기',
};

export const EVERYDAY_BABYFACE_IMAGE = {
  src: salesCDN(`everyday_babyface.jpg`),
  alt: '사진으로 동영상으로 매일보는 베이비페이스',
};

export const BABYFACE_DETAIL_IMAGES = [
  ...EVENT_IMAGES,
  EVERYDAY_BABYFACE_IMAGE,
  ...Array(13)
    .fill()
    .map((_, idx) => {
      return {
        src: babyfaceCDN(`detail_${String(idx + 1).padStart(2, '0')}@3x.jpg`),
        alt: '베이비페이스 상품 상세',
      };
    }),
  THE_GOLDEN_COMPASS_VIDEO,
  ...Array(4)
    .fill()
    .map((_, idx) => {
      return {
        src: babyfaceCDN(`detail_${String(idx + 14).padStart(2, '0')}@3x.jpg`),
        alt: '베이비페이스 상품 상세',
      };
    }),
  ...BABYFACE_ACC_DETAIL_IMAGES,
];

// FYI : 1rem = 22.6133px
export const BABYFACE_DETAIL_GIFS = [
  {
    src: babyfaceCDN(`detail_02_conversion_processing_v4.gif`),
    alt: '베이비페이스 변환과정',
    style: {
      width: '16.875rem',
      height: '16.75rem',
      position: 'absolute',
      top: 'calc(28.125rem + 21.664rem + 15.125rem)',
    },
  },
  {
    src: babyfaceCDN(`detail_05_babyface4d_v1.gif`),
    alt: '베이비페이스4d 예시',
    style: {
      width: '14.625rem',
      height: '14.625rem',
      position: 'absolute',
      top: 'calc(28.125rem + 21.664rem + 54.813rem)',
    },
  },
];

export const IMG_ULTRA_AVALIABLE = salesCDN('초음파_분석_가능.png');
export const IMG_ULTRA_UNAVALIABLE = salesCDN('초음파_분석_불가능.png');
export const IMG_CLEAFACE = salesCDN('clearface-link.png');
